module.exports = __webpack_public_path__ + "img/open_transparent.563fd30a.svg";